import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import BannerSlider from "../Element/BannerSlider";
import TeacherSlider from "../Element/TeacherSlider";
import GallerySlider from "../Element/GallerySlider";

import icon1 from "./../../images/icon/icon1.jpg";
import icon2 from "./../../images/icon/icon2.jpg";
import icon3 from "./../../images/icon/icon3.jpg";
import icon4 from "./../../images/icon/icon4.jpg";
import bgimg1 from "./../../images/line.png";
import bgimg2 from "./../../images/background/bg1.png";
import bgimg3b from "./../../images/background/bg3_b.png";
import bgimg3 from "./../../images/line2.png";

const iconBlog = [
  { image: icon1, title1: "Creative Thinking", title2: "Leads to Creation" },
  { image: icon2, title1: "To Be Well and", title2: "Emotionally Aware" },
  {
    image: icon3,
    title1: "Actively Independent",
    title2: "Compassionately Helpful",
  },
  {
    image: icon4,
    title1: "Applying Knowledge",
    title2: "for a Meaningful Life",
  },
];
const iconBlog2 = [
  {
    icon: <i className="flaticon-rattle text-blue" />,
    title: "Nurturing Little Minds",
    description:
      "Helping young minds grow and explore through creativity and learning.",
  },
  {
    icon: <i className="flaticon-bricks text-green" />,
    title: "Speaking for Myself",
    description:
      "Speaking for myself, I believe our choices shape our journey and growth.",
  },
  {
    icon: <i className="flaticon-puzzle text-orange" />,
    title: "Delight",
    description:
      "Delight is a feeling of joy and happiness that comes from special moments, surprises, or simple pleasures in life",
  },
];

const Index1 = () => {
  useEffect(() => {
    document.body.setAttribute("data-theme-color", "color_1");
  }, []);
  return (
    <Fragment>
      <Header />
      <div className="page-content bg-white">
        <BannerSlider />
        <div className="admission-banner section-full position-relative">
          <div className="container-fluid p-0">
            <img
              src={bgimg3b}
              alt="Bright Future School admission"
              className="admission-banner__img"
            />
            <div className="admission-banner__cta">
              <Link to="https://forms.gle/qTAhBiXKSB4AkqTq5" className="btn btn-md radius-xl">
                For Admission
              </Link>
            </div>
          </div>
        </div>



        <div className="content-block">
          {/*  About Us */}
          <div className="section-full bg-white content-inner-1 text-center">
            <div className="container">
              <div className="section-head">
                <h2 className="head-title text-secondry">
                  Welcome to Bright Future
                </h2>
                <p>Shaping Young Minds, Creating Bright Futures!</p>
              </div>
              <div className="row">
                {iconBlog.map((data, index) => (
                  <div
                    className="col-lg-3 col-md-6 col-sm-6 col-12"
                    key={index}
                  >
                    <div className="icon-bx-wraper sr-iconbox m-b20">
                      <div className="icon-lg m-b20">
                        <Link to={"#"} className="icon-cell">
                          <img src={data.image} alt="" />
                        </Link>
                      </div>
                      <div className="icon-content">
                        <h6 className="dlab-tilte">
                          {data.title1}
                          <br />
                          {data.title2}
                        </h6>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/*  About Us End*/}
          <div
            className="section-full bg-white content-inner-2 about-box section-bg-soft"
            style={{
              backgroundImage: "url(" + bgimg1 + ")",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-7 col-md-12 col-sm-12 col-12">
                  <div className="section-head">
                    <h2 className="head-title text-secondry">
                      Dreaming of a Smart and <br />
                      Bright Future for <br />
                      Your Child?
                    </h2>
                    <p>
                      Every parent envisions a future where their child excels,
                      thinks critically, and achieves great success. Education
                      is the foundation that nurtures intelligence, creativity,
                      and confidence. By providing the right learning
                      environment, encouragement, and guidance, we can help
                      children unlock their full potential.
                    </p>
                    {/* <Link to={"./faqs"} className="btn btn-md kids-btn radius-xl">Learn more</Link> */}
                  </div>
                </div>
                <div className="col-lg-5 col-md-12 col-sm-12 col-12">
                  {iconBlog2.map((item, index) => (
                    <div className="icon-bx-wraper left" key={index}>
                      <div className="icon-lg m-b20">
                        <span className="icon-cell">{item.icon}</span>
                      </div>
                      <div className="icon-content">
                        <h2 className="dlab-tilte">{item.title}</h2>
                        <p>{item.description}</p>{" "}
                        {/* Unique description for each item */}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <EducationBanner />
          <div className="section-full bg-white content-inner-1">
            <div className="container">
              <div className="section-head text-center">
                <h2 className="head-title text-secondry">
                  Gallery of our classes
                </h2>
                <p>
                  Where Design Meets Discovery – A Better Place to Learn!
                </p>
              </div>
              <GallerySlider />
            </div>
          </div>
          <div
            className="section-full bg-white content-inner-1 section-bg-soft"
            style={{
              backgroundImage: "url(" + bgimg3 + ")",
            }}
          >
            <div className="container">
              <div className="section-head text-center">
                <h2 className="head-title text-secondry">About the Teachers</h2>
                <p>
                  We have an excellent teacher to child ratio at our
                  Kindergarten to ensure that each child receives the attention
                  he or she needs
                </p>
              </div>
              <TeacherSlider />
            </div>
          </div>
          {/* <div className="section-full bg-white content-inner-1">
            <div className="container">
              <div className="section-head text-center">
                <h2 className="head-title text-secondry">
                  Testimonials about center
                </h2>
                <p>
                  We have an excellent teacher to child ratio at our
                  Kindergarten to ensure that each child receives the attention
                  he or she needs
                </p>
              </div>
              <TestiMonialSlider />
            </div>
          </div> */}
          {/* <div className="section-full bg-white content-inner">
            <div className="container">
              <div className="section-head text-center">
                <h2 className="head-title text-secondry">From the Blog</h2>
                <p>
                  We have an excellent teacher to child ratio at our
                  Kindergarten to ensure that each child receives the attention
                  he or she needs
                </p>
              </div>
              <FromSlider />
            </div>
          </div> */}
        </div>
      </div>
      <Footer />
    </Fragment>
  );
};
function EducationBanner() {
  return (
    <>
      <div
        className="section-full bg-white content-inner-2 about-content bg-img-fix"
        style={{ backgroundImage: "url(" + bgimg2 + ")" }}
      >
        <div className="about-overlay-box"></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="section-head">
                <h2 className="head-title text-yellow">
                  Building a Strong Foundation
                  <br />
                  from Birth
                </h2>
                <p className="text-white">
                  Our Children's Academy, in collaboration with one of the
                  city's most established private schools, has launched a joint
                  school preparation program. This initiative aims to foster
                  holistic development and socialization, ensuring a smooth
                  transition into the top educational institutions in our city.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-12"></div>
          </div>
        </div>
      </div>
    </>
  );
}
export { EducationBanner };
export default Index1;
